import Bridge from "../../turbo/bridge";

// The formats the file_server accepts for an upload used as an image
// (FileServer::Config.image_upload_types, tixxt/core#694). BMP, ICO, PSD & co.
// can be neither resized nor shown everywhere and are rejected there.
// HEIC/HEIF and TIFF are delivered as their JPEG variant.
const IMAGE_TYPES = [
  "image/jpeg",
  "image/png",
  "image/gif",
  "image/webp",
  "image/avif",
  "image/heic",
  "image/heif",
  "image/tiff",
];
// Not every browser and OS maps .heic or .avif to a MIME type, so the
// extensions are listed as well.
const IMAGE_EXTENSIONS = [
  ".jpg",
  ".jpeg",
  ".png",
  ".gif",
  ".webp",
  ".avif",
  ".heic",
  ".heif",
  ".tif",
  ".tiff",
];

// `accept` value for an image upload field. SVG only where it is wanted on
// purpose (e.g. the logo in the design manager).
export default function imageAccept({ svg = false } = {}): string {
  // The native file chooser of turbo-android uses the first accept entry
  // verbatim as the intent MIME type (#112), so a list would only offer JPEGs.
  // The file_server rejects anything else anyway.
  if (window.isApp && Bridge.isAndroid()) return "image/*";

  return [
    ...IMAGE_TYPES,
    ...(svg ? ["image/svg+xml"] : []),
    ...IMAGE_EXTENSIONS,
    ...(svg ? [".svg"] : []),
  ].join(",");
}

// Whether a file matches an `accept` value — a MIME type ("image/png"), a
// wildcard ("image/*") or an extension (".png"), as the file dialog applies
// it. A drop bypasses the dialog, so the drop zone checks with this.
export function acceptsFile(
  accept: string,
  file: { name: string; type: string },
): boolean {
  const entries = accept
    .split(",")
    .map((entry) => entry.trim().toLowerCase())
    .filter(Boolean);
  if (entries.length === 0 || entries.includes("*")) return true;

  const name = file.name.toLowerCase();
  const type = file.type.toLowerCase();

  return entries.some((entry) => {
    if (entry.startsWith(".")) return name.endsWith(entry);
    if (entry.endsWith("/*")) return type.startsWith(entry.slice(0, -1));
    return type === entry;
  });
}
